import React from 'react';
import Hero from '@/components/home/Hero';
import WorkflowSelector from '@/components/home/WorkflowSelector';
import InteractiveDemo from '@/components/home/InteractiveDemo';
import OfferLadder from '@/components/home/OfferLadder';
import PilotOffer from '@/components/home/PilotOffer';
import HowItWorks from '@/components/home/HowItWorks';
import Measurement from '@/components/home/Measurement';
import Controls from '@/components/home/Controls';
import ConsultingPreview from '@/components/home/ConsultingPreview';
import AboutPreview from '@/components/home/AboutPreview';
import SectionHeader from '@/components/site/SectionHeader';
import Faq from '@/components/site/Faq';
import GoldText from '@/components/site/GoldText';
import ClosingCta from '@/components/site/ClosingCta';
import { faqs } from '@/content/faq';
import { usePageMeta } from '@/hooks/usePageMeta';

const Index = () => {
  usePageMeta(
    'GoldCrusade',
    'Put AI to work. Start with one assistant. A free discovery call, a scoped AI assistant pilot, and optional ongoing consulting.',
  );

  return (
    <>
      <Hero />
      <WorkflowSelector />
      <InteractiveDemo />
      <OfferLadder />
      <PilotOffer />
      <HowItWorks />
      <Measurement />
      <Controls />
      <ConsultingPreview />
      <AboutPreview />
      <section aria-labelledby="faq-title" className="border-t border-rule">
        <div className="section-container grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
          <SectionHeader
            id="faq-title"
            eyebrow="10 / Questions"
            title={
              <>
                Frequently asked <GoldText>questions.</GoldText>
              </>
            }
          />
          <Faq items={faqs} />
        </div>
      </section>
      <ClosingCta
        title={
          <>
            What would you stop
            <br />
            doing <GoldText>manually?</GoldText>
          </>
        }
        footnote="Free discovery call. Scoped pilot. Ongoing consulting is optional."
      >
        <p>
          Bring us one workflow. We’ll help you determine whether an AI assistant is the right fit—and what a useful
          pilot should prove.
        </p>
      </ClosingCta>
    </>
  );
};

export default Index;
